import React   from "react";
import { Link, useHistory } from "react-router-dom";

import ROUTES from "../../../utils/routes";

import { useSelector,useDispatch }              from "react-redux";
import { 
    setCadenaBusquedaAction,
    setResultsPageAction
}                                               from "../../../actions/searchActions";


import { 
    encodeNumber as nToString
}   from "../../../API/request";

const ResultsOverlay = () => {
    const dispatch = useDispatch();
    let history = useHistory()

    let busquedaObj = useSelector((state) => state.search);

    const closeOverlay = () =>{
        dispatch(setCadenaBusquedaAction("",busquedaObj.articulos));
    }
    const copyFilterResults = () =>{
        dispatch(setResultsPageAction(busquedaObj.filtroArticulos));
    }
    const handleClick = () => {
        copyFilterResults();
        closeOverlay();
        history.push( ROUTES.SEARCHRESULTS);
    }

    return (
        <div className={busquedaObj.cadenaBusqueda !== "" ? "preResultsNav active" : "preResultsNav"}>
            <div className="preResultsNav-find">
                <div className="preResultsNav-find-elements">
                    <div className="preResultsNav-find-elements-resulst">
                        {
                            busquedaObj.filtroArticulos.length < 6 &&
                                busquedaObj.filtroArticulos.map( (articuloItem, i) => 
                                    <Link 
                                        to={ROUTES.DETAILSEMPTY + nToString(articuloItem.id)}
                                        onClick={(e) => closeOverlay()}
                                        key={"articleFilter-"+i}
                                        >{articuloItem.nombre}
                                    </Link>
                                )
                        }
                        {
                            busquedaObj.filtroArticulos.length > 5 && 
                                <>
                                    <Link to={ROUTES.DETAILSEMPTY + nToString(busquedaObj.filtroArticulos[0].id)} onClick={(e) => closeOverlay()}>{busquedaObj.filtroArticulos[0].nombre}</Link>
                                    <Link to={ROUTES.DETAILSEMPTY + nToString(busquedaObj.filtroArticulos[1].id)} onClick={(e) => closeOverlay()}>{busquedaObj.filtroArticulos[1].nombre}</Link>
                                    <Link to={ROUTES.DETAILSEMPTY + nToString(busquedaObj.filtroArticulos[2].id)} onClick={(e) => closeOverlay()}>{busquedaObj.filtroArticulos[2].nombre}</Link>
                                    <Link to={ROUTES.DETAILSEMPTY + nToString(busquedaObj.filtroArticulos[3].id)} onClick={(e) => closeOverlay()}>{busquedaObj.filtroArticulos[3].nombre}</Link>
                                    <Link to={ROUTES.DETAILSEMPTY + nToString(busquedaObj.filtroArticulos[4].id)} onClick={(e) => closeOverlay()}>{busquedaObj.filtroArticulos[4].nombre}</Link>
                                </>
                        }
                        {
                            busquedaObj.filtroArticulos.length === 0 && 
                                <>
                                    <span>No se encontraron resultados</span>
                                </>
                        }
                    </div>

                    {
                        busquedaObj.filtroArticulos.length > 1 &&
                            <button onClick={handleClick}>
                                Mostrar todos los resultados
                                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 16.9L15.5 11.5 10 6.1" fill="none" stroke="currentColor"></path>
                                </svg>
                            </button>
                    }
                </div>
            </div>
            <div className="preResultsNav-overlay" onClick={(e) => closeOverlay()}></div>
        </div>
    );
};

export default ResultsOverlay;
